import { render, staticRenderFns } from "./MainMenu_v2.vue?vue&type=template&id=e4a76f56&scoped=true"
import script from "./MainMenu_v2.vue?vue&type=script&lang=ts"
export * from "./MainMenu_v2.vue?vue&type=script&lang=ts"
import style0 from "./MainMenu_v2.vue?vue&type=style&index=0&id=e4a76f56&prod&scoped=true&lang=css"
import style1 from "./MainMenu_v2.vue?vue&type=style&index=1&id=e4a76f56&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a76f56",
  null
  
)

export default component.exports